import React, { useState } from "react";

const ChargesTab = () => {
  const [showAdd, setShowAdd] = useState(false);
  const handleCloseAdd = () => setShowAdd(false);
  const handleShowAdd = () => setShowAdd(true);

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => setShowEdit(true);
  return (
    <>
      <div className="row pb-3">
        <div className="col-md-12">
          <div className="card px-3 py-2">
            <div className="row">
            <div className="table-responsive table-height">
              <table className="table table-striped table-sm">
                <thead>
                  <tr>
                    <th scope="col">Sr No</th>
                    <th scope="col">Invoice Number</th>
                    <th scope="col">Date</th>
                    <th scope="col">TOI</th>
                    <th scope="col">Currency</th>
                    <th scope="col">Product Value</th>
                    <th scope="col">Other Chrgs</th>
                    <th scope="col">Invoice Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default ChargesTab;
